import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { LocalStorageService } from '../localstorage.service';

@Injectable()
export class AuthGuard implements CanActivate {


  constructor(private authService: AuthService, private router: Router, private localStorageService: LocalStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    this.localStorageService.setLocalDataStr('url', '/Dashboard' + state.url)
    const taskId = route.data.taskId;
    const name = this.getTaskName(taskId);
    document.getElementsByTagName('title')[0].innerHTML = name
    this.getScreenName(route.data.screenId);
  }

  
  getScreenName(ScreenId: any) {
    const ScreenList = this.localStorageService.getLocalData('SideBarMenulist')
    if (ScreenList.length > 0) {
      const screen = ScreenList.find((e: any) => e.screenId == ScreenId);
      if (screen != undefined) {
        localStorage.setItem('screenId', ScreenId);
        return screen.screenTitle;
      }
    }
    return '';
  }

  getTaskName(taskId: any) {
    const ScreenList = this.localStorageService.getLocalData('SideBarMenulist')
    if (ScreenList.length > 0) {
      const screen = ScreenList.find((e: any) => e.taskId == taskId);
      if (screen != undefined) {
        localStorage.setItem('taskId', taskId);
        return screen.screenTitle;
      }
    }
    return '';
  }
}
